export const applicationSettingConstants = {
    APPLICATION_SETTING_GET_BY_CREATION_CATEGORY_REQUEST: 'APPLICATION_SETTING_GET_BY_CREATION_CATEGORY_REQUEST',
    APPLICATION_SETTING_GET_BY_CREATION_CATEGORY_SUCCESS: 'APPLICATION_SETTING_GET_BY_CREATION_CATEGORY_SUCCESS',
    APPLICATION_SETTING_GET_BY_CREATION_CATEGORY_FAILURE: 'APPLICATION_SETTING_GET_BY_CREATION_CATEGORY_FAILURE'
};